<ng-template #attachmentValue dsCrisLayoutLoader></ng-template>
